/* SLAY — 99p promo tin cart upsell
   Loaded from theme.liquid so it always runs regardless of cart state.
   Markup: snippets/slay-cart-upsell.liquid

   Flavour AND strength are pulled live from the collection, so out-of-stock
   variants drop off automatically and nothing needs hardcoding.
*/
(function () {
  var P = {
    // Products are read from this collection. Only in-stock pouch variants show.
    COLLECTION_HANDLE: 'slay-nicotine-pouches',
    ALLOWED_TYPES: ['nicotine pouch', 'nicotine pouches'],

    promoProperties: { _slay_promo: '99p' },
    PAID_TINS_REQUIRED: 4,       // unlocks at EXACTLY 4 paid tins
    hideFlavoursInCart: true,    // don't offer a flavour already in the basket

    isPaidTin: function (item) {
      if (item.properties && item.properties._slay_promo) return false;
      if (item.selling_plan_allocation) return false;
      var t = (item.product_type || '').toLowerCase();
      return P.ALLOWED_TYPES.indexOf(t) !== -1;
    }
  };
  window.SLAY_PRICING = P;

  var catalogue = null;   // [{ name, handle, strengths:[{label, variantId}] }]

  /* ---------- catalogue ---------- */
  function loadCatalogue() {
    if (catalogue) return Promise.resolve(catalogue);
    return fetch('/collections/' + P.COLLECTION_HANDLE + '/products.json?limit=250', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        catalogue = (data.products || [])
          .filter(function (p) {
            var t = (p.product_type || '').toLowerCase();
            return P.ALLOWED_TYPES.indexOf(t) !== -1;
          })
          .map(function (p) {
            var strengths = (p.variants || [])
              .filter(function (v) { return v.available; })
              .map(function (v) {
                return { label: v.title, variantId: String(v.id) };
              });
            return { name: p.title, handle: p.handle, strengths: strengths };
          })
          .filter(function (p) { return p.strengths.length; });
        return catalogue;
      })
      .catch(function () { catalogue = []; return catalogue; });
  }

  /* ---------- offer logic ---------- */
  function paidTins(cart) {
    return cart.items.reduce(function (n, i) { return n + (P.isPaidTin(i) ? i.quantity : 0); }, 0);
  }
  function promoInCart(cart) {
    return cart.items.some(function (i) { return i.properties && i.properties._slay_promo; });
  }
  function flavourInCart(cart, flavourName) {
    var want = String(flavourName).trim().toLowerCase();
    return cart.items.some(function (i) {
      var title = String(i.product_title || i.title || '').trim().toLowerCase();
      return title.indexOf(want) !== -1;
    });
  }
  function offerFor(cart) {
    if (!catalogue || !catalogue.length) return null;
    if (promoInCart(cart)) return null;                       // max one per order
    if (paidTins(cart) !== P.PAID_TINS_REQUIRED) return null; // exactly 4, hide at 5+

    var flavours = P.hideFlavoursInCart
      ? catalogue.filter(function (f) { return !flavourInCart(cart, f.name); })
      : catalogue.slice();
    if (!flavours.length) return null;

    return {
      title: 'Your 99p tin is unlocked',
      text: 'Try another flavour for 99p.',
      flavours: flavours
    };
  }

  /* ---------- rendering ---------- */
  function inSummary(root) {
    return !!(root.closest && root.closest('.cart-drawer__summary, .cart__summary, .cart-drawer__footer, .totals'));
  }
  function activeRoots() {
    var all = document.querySelectorAll('[data-slay-upsell]');
    var picked = [], seen = {};
    Array.prototype.forEach.call(all, function (root) {
      if (inSummary(root)) { root.hidden = true; return; }
      var ctx = root.getAttribute('data-context') || 'drawer';
      if (seen[ctx]) { root.hidden = true; return; }
      seen[ctx] = true;
      picked.push(root);
    });
    return picked;
  }

  function fillStrengths(root, flavour) {
    var sSel = root.querySelector('.slay-upsell__strength');
    sSel.innerHTML = flavour.strengths.map(function (s) {
      return '<option value="' + s.variantId + '">' + s.label + '</option>';
    }).join('');
    sSel.hidden = flavour.strengths.length <= 1;
  }

  function renderRoot(root, cart) {
    var offer = offerFor(cart);
    if (!offer) { root.hidden = true; root.removeAttribute('data-slay-sig'); return; }

    var sig = offer.flavours.map(function (f) {
      return f.handle + ':' + f.strengths.map(function (s) { return s.variantId; }).join('.');
    }).join(',');
    if (root.getAttribute('data-slay-sig') === sig && !root.hidden) return;
    root.setAttribute('data-slay-sig', sig);
    root.hidden = false;

    root.querySelector('.slay-upsell__title').textContent = offer.title;
    root.querySelector('.slay-upsell__text').textContent = offer.text;

    var fSel = root.querySelector('.slay-upsell__flavour');
    fSel.innerHTML = offer.flavours.map(function (f, i) {
      return '<option value="' + i + '">' + f.name + '</option>';
    }).join('');
    fSel.hidden = offer.flavours.length <= 1;

    root._slayFlavours = offer.flavours;
    fillStrengths(root, offer.flavours[0]);
    root.querySelector('.slay-upsell__add').disabled = false;
  }

  function refreshAll() {
    var roots = activeRoots();
    if (!roots.length) return Promise.resolve();
    return loadCatalogue()
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { roots.forEach(function (root) { renderRoot(root, cart); }); })
      .catch(function () {});
  }

  /* ---------- theme cart refresh (Horizon section rendering) ---------- */
  function refreshThemeCart() {
    // New SLAY cart page: re-render its section from the server, then let it re-bind.
    var sct = document.querySelector('[data-sct][data-section-id]');
    if (sct) {
      var sid = sct.getAttribute('data-section-id');
      var wrap = document.getElementById('shopify-section-' + sid);
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + sid);
          if (fresh && wrap) { wrap.innerHTML = fresh.innerHTML; wrap.querySelectorAll('.sm-reveal').forEach(function (el) { el.classList.add('is-in'); }); }
          document.dispatchEvent(new CustomEvent('slay-cart:rerendered'));
        })
        .catch(function () {});
    }
    var comp = document.querySelector('cart-items-component[data-section-id]');
    if (!comp) return Promise.resolve();
    var sectionId = comp.getAttribute('data-section-id');
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'text/html' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-items-component');
        if (fresh && comp.parentNode) comp.replaceWith(fresh);
      })
      .catch(function () {});
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: P.promoProperties }] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }

  /* ---------- events ---------- */
  // Flavour change repopulates the strength list
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('.slay-upsell__flavour') : null;
    if (!sel) return;
    var root = sel.closest('[data-slay-upsell]');
    if (!root || !root._slayFlavours) return;
    var flavour = root._slayFlavours[Number(sel.value)];
    if (flavour) fillStrengths(root, flavour);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.slay-upsell__add') : null;
    if (!btn) return;
    var root = btn.closest('[data-slay-upsell]');
    if (!root) return;
    var sSel = root.querySelector('.slay-upsell__strength');
    var variantId = sSel && sSel.value;
    if (!variantId) return;
    e.preventDefault();
    btn.disabled = true;
    addToCart(variantId)
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        return refreshThemeCart();
      })
      .then(refreshAll)
      .catch(function (err) { console.warn('SLAY upsell add failed:', err); btn.disabled = false; });
  });

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update', 'cart-drawer:open', 'drawerOpen', 'cart:open']
    .forEach(function (evt) { document.addEventListener(evt, refreshAll); });

  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    return _fetch.apply(this, args).then(function (res) {
      try {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) setTimeout(refreshAll, 120);
      } catch (e) {}
      return res;
    });
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this._slayUrl = u; return _open.apply(this, arguments); };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    this.addEventListener('load', function () {
      try {
        if (typeof self._slayUrl === 'string' && /\/cart\/(add|change|update|clear)/.test(self._slayUrl)) setTimeout(refreshAll, 120);
      } catch (e) {}
    });
    return _send.apply(this, arguments);
  };

  var t;
  new MutationObserver(function (muts) {
    var relevant = muts.some(function (m) {
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType === 1 && ((n.matches && n.matches('[data-slay-upsell]')) || (n.querySelector && n.querySelector('[data-slay-upsell]')))) return true;
      }
      if (m.type === 'attributes' && m.target && m.target.matches && m.target.matches('dialog') && m.target.hasAttribute('open')) return true;
      return !!(m.target && m.target.closest && m.target.closest('cart-items-component, cart-drawer-component'));
    });
    if (!relevant) return;
    clearTimeout(t);
    t = setTimeout(refreshAll, 100);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

  if (document.readyState !== 'loading') refreshAll();
  else document.addEventListener('DOMContentLoaded', refreshAll);
  window.addEventListener('load', refreshAll);
})();